import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const getToken = () => localStorage.getItem('te_token');
export const setToken = (t) => t ? localStorage.setItem('te_token', t) : localStorage.removeItem('te_token');

const api = axios.create({ baseURL: API, withCredentials: true });
api.interceptors.request.use((cfg) => {
  const t = getToken();
  if (t) cfg.headers.Authorization = `Bearer ${t}`;
  return cfg;
});

export const mediaUrl = (pid, kind, download = false, v = '') =>
  `${API}/projects/${pid}/media/${kind}?token=${encodeURIComponent(getToken() || '')}${download ? '&download=1' : ''}${v ? `&v=${encodeURIComponent(v)}` : ''}`;

export const imageUrl = (pid, idx, v = '') =>
  `${API}/projects/${pid}/image/${idx}?token=${encodeURIComponent(getToken() || '')}${v ? `&v=${encodeURIComponent(v)}` : ''}`;

export const assetUrl = (aid, v = '', download = false) =>
  `${API}/images/${aid}/file?token=${encodeURIComponent(getToken() || '')}${download ? '&download=1' : ''}${v ? `&v=${encodeURIComponent(v)}` : ''}`;

export default api;
